module.exports = __webpack_public_path__ + "static/img/RSP.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RSP.png
// module id = gFny
// module chunks = 0